import { HttpMethod } from "../../common/constants/http-requests";
import { httpRequest } from "../../common/utils/http-request";
import { SOW_API, PROJECT_ADMIN_API } from "../api";

export const getSOWDetails = (pageNo, pageSize, sortDir, sortBy, searchData, clientId) => {
  const base = `${SOW_API}/get-sows?page=${pageNo}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchKey=${encodeURIComponent(searchData || "")}`;
  const withClient =
    clientId != null && clientId !== "" && !Number.isNaN(Number(clientId))
      ? `${base}&clientId=${encodeURIComponent(String(clientId))}`
      : base;
  return httpRequest({
    url: withClient,
    method: HttpMethod.GET,
  });
};

export const postSOWDetails = (data) =>
  httpRequest({
    url: `${SOW_API}/create-sow`,
    method: HttpMethod.POST,
    data: data,
  });

export const updateSOWDetails = (data) =>
  httpRequest({
    url: `${SOW_API}/${data.sowId ?? data.SOWId}/update-sow`,
    method: HttpMethod.PUT,
    data: data,
  });

export const getSOWById = (sowId) =>
  httpRequest({
    url: `${SOW_API}/${sowId}`,
    method: HttpMethod.GET,
  });

export const deleteSOWDetails = (sowId) =>
  httpRequest({
    url: `${SOW_API}/${sowId}/delete-sow`,
    method: HttpMethod.DELETE,
  });

export const linkProjectsToSOW = (sowId, projectIds) =>
  httpRequest({
    url: `${SOW_API}/link-projects`,
    method: HttpMethod.POST,
    data: { sowId, projectIds },
  });

export const getLinkedProjectsBySOWId = (sowId) =>
  httpRequest({
    url: `${SOW_API}/${sowId}/linked-projects`,
    method: HttpMethod.GET,
  });

export const getAllocationsBySOWId = (sowId) =>
  httpRequest({
    url: `${SOW_API}/${sowId}/allocations`,
    method: HttpMethod.GET,
  });

export const createSOWAllocation = (sowId, data) =>
  httpRequest({
    url: `${SOW_API}/${sowId}/allocations`,
    method: HttpMethod.POST,
    data,
  });

export const updateSOWAllocation = (allocationId, data) =>
  httpRequest({
    url: `${SOW_API}/allocations/${allocationId}`,
    method: HttpMethod.PUT,
    data,
  });

export const deleteSOWAllocation = (allocationId) =>
  httpRequest({
    url: `${SOW_API}/allocations/${allocationId}`,
    method: HttpMethod.DELETE,
  });

export const getSOWResourcingDetails = (sowId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/sow/${sowId}/resourcing-details`,
    method: HttpMethod.GET,
  });

export const updateSOWResourcingDetails = (sowId, data) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/sow/${sowId}/resourcing-details`,
    method: HttpMethod.PUT,
    data: data,
  });

export const getLinkedProjectsListBySOWId = (sowId) =>
  httpRequest({
    url: `${SOW_API}/${sowId}/linked-projects-list`,
    method: HttpMethod.GET,
  });

export const getSOWAllocationProjection = (sowId, projectId = null) =>
  httpRequest({
    url: `${SOW_API}/get-sow-allocation-projection?sowId=${sowId}${projectId != null && projectId !== "" && projectId !== 0 ? `&projectId=${projectId}` : ""}`,
    method: HttpMethod.GET,
  });
